import Main from '../views/index.vue'
import { NavigationGuardNext, Route } from 'vue-router'

export default function() {
  return [
    {
      path: '/play',
      component: Main,
      async beforeEnter(to: Route, from: Route, next: NavigationGuardNext) {
        const body = document.querySelector('body')
        if (body) {
          body.setAttribute('class', 'play')
        }
        next()
      },
      scrollBehavior() {
        return { x: 0, y: 0 }
      },
      children: [
        {
          // 学习
          // path: 'study/:schemaId/:learningId/:courseId/:courseWareId',
          path: 'study/:token/:courseWareId?',
          query: {
            backUrl: ''
          },
          name: 'PlayCourseStudy',
          meta: { needLogin: true },
          components: {}
        },
        {
          // 试听
          path: 'listen/:token/:courseWareId?',
          name: 'PlayCourseListen',
          query: {
            backUrl: ''
          },
          components: {}
        },
        {
          // 预览课程
          path: 'previewCourse/:token/:courseWareId?',
          name: 'PlayCoursePreview',
          components: {}
        },
        {
          // 预览课件
          path: 'previewCourseWare/:courseWareId',
          components: {}
        }
      ]
    }
  ]
}
